import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from '@mui/material';
import React, { useState } from 'react';
import type { StaffProfilePatch, StaffUser } from '../../data/types';

const FIELDS: { key: keyof StaffProfilePatch; label: string }[] = [
  { key: 'name', label: 'Name' },
  { key: 'title', label: 'Job title' },
  { key: 'email', label: 'Email' },
  { key: 'phone', label: 'Mobile' },
  { key: 'address', label: 'Work address' },
];

interface Props {
  user: StaffUser;
  onClose: () => void;
  onSave: (patch: StaffProfilePatch) => void;
}

export default function StaffProfileDialog({ user, onClose, onSave }: Props) {
  const [draft, setDraft] = useState<StaffProfilePatch>({
    name: user.name,
    title: user.title ?? '',
    email: user.email ?? '',
    phone: user.phone ?? '',
    address: user.address ?? '',
  });
  return (
    <Dialog open onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ fontWeight: 700 }}>Edit profile</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          {FIELDS.map((field) => (
            <TextField
              key={field.key}
              size="small"
              label={field.label}
              required={field.key === 'name'}
              value={draft[field.key] ?? ''}
              onChange={(event) => setDraft({ ...draft, [field.key]: event.target.value })}
            />
          ))}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button
          variant="contained"
          disabled={!draft.name?.trim()}
          onClick={() => onSave({ ...draft, name: draft.name?.trim() })}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
